import React, { useEffect, useRef, useState } from "react";
import "./rentalSummaryDetails.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowRight, Info, Plus } from "react-feather";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LoaderPage from "../command/loader/loader";
import { toast } from "react-toastify";

interface PaymentFormProps {
  sessionid: string;
  publicKey: string;
  customerinfo: any;
  orderdetails?: any;
  producttotalrate?: number;
  handleAddCardClick?: () => void;
  showNewCardForm?: boolean;
  totalPayablAmount?: number;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  sessionid,
  publicKey,
  customerinfo,
  orderdetails,
  producttotalrate,
  handleAddCardClick,
  showNewCardForm,
  totalPayablAmount,
}) => {
  const formRef = useRef<HTMLFormElement>(null);
  const acquiredRef = useRef<any>(null);
  const [accComponents, setComponents] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(true);

  const initializeAcquired = () => {
    acquiredRef.current = new Acquired(publicKey);
    const paymentEnv = process.env.REACT_APP_ACQUIRED_PAYMENT_ENV ?? "";
    const options = {
      session: sessionid,
      environment: paymentEnv,
    };
    const components = acquiredRef.current.components(options);

    const style = {
      base: {
        color: "black",
        backgroundColor: "#fff",
        padding: "1rem 1rem",
        fontFamily: "Poppins",
        border: "1px solid #cccccc",
        borderRadius: "13px",
        background: "#ffffff",
        height: "58px",
        margin: "0",
      },
      focus: {
        color: "green",
        borderColor: "green",
      },
      invalid: {
        color: "#dc3545",
        borderColor: "#dc3545",
      },
      placeholder: {
        color: "gray",
      },
    };

    components.create("payment", { style }).mount("#payment-component");
    components.on("blur", (response: any) => {
      acquiredRef.current.showComponentErrorMessage(
        ".component-error",
        response
      );
      // document.querySelector('#error-message')!.textContent = JSON.stringify(response);
    });
    setComponents(components);

  };

  const handleSubmit = async () => {
    // event.preventDefault();
    const confirmParams = {
      payment: {
        reference: "test",
        create_card: true,
      },
      customer: {
        first_name: customerinfo?.firstname,
        last_name: customerinfo?.lastname,
        dob: customerinfo?.dob,
        ip: "127.0.0.1",
        custom_data: "L3BheW1lbnQtbGlua3MgcGF5IGN1c3RvbV9kYXRh",
        billing: {
          address: {
            line_1: customerinfo?.billingAddress?.housename,
            line_2: customerinfo?.billingAddress?.street,
            city: customerinfo?.billingAddress?.town,
            state: "",
            postcode: customerinfo?.billingAddress?.postalcode,
            country_code: "",
          },
          email: customerinfo?.email,
          phone: {
            country_code: "",
            number: "",
          },
        },
      },
      webhook_url: "",
    };
    try {
      const response = await acquiredRef.current
        .confirmPayment({
          components: accComponents,
          confirmParams: confirmParams,
        })
        .catch((error: any) => {
          console.log("Errr:::", error);
          console.log("Errror while payment::", error);
        });

      console.log("Response::", response);
      if (response.isTdsPending()) {
        window.location.href = response.data.redirect_url;
      } else if (response.isSuccess()) {
        const orderId = response.data.order_id || "";
        navigate(`/congratulations?orderId=${orderId}&status=success`);
      } else if (response.isError()) {

        acquiredRef.current.showComponentErrorMessage(
          ".component-error",
          response.data
        );
      }
      if (response?.data?.status === "error") {
        console.log("Error::", response);
        toast.error(response?.data?.message);
        // setShowToast(true);
        // setToastMessage(response.data.message);
        // setToastType("danger");
      }
    } catch (error: any) {
      console.log("Error::", error);
      console.error("Payment submission error:", error);
    }
  };

  useEffect(() => {
    if (Acquired) {
      const interval = setInterval(() => {
        setLoading(false);
      }, 900);
      initializeAcquired();
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <div>
      {loading && <div className="payment-form-loader"><h4>Loading<span className="payment-loader-dotes"></span></h4></div>}
      <form id="payment-form" className="form-main" >
        <div id="payment-component"></div>
      </form>
      {/* For saved card */}
      {/* <div className='add-payment-card'>
        <div className={`btn add-card`} onClick={handleAddCardClick}>
          {showNewCardForm ? (
            <>Add new card <Plus size={20} className='mb-1' /></>
          ) : (
            <>Goto Saved Card <ArrowRight size={20} className='' /></>
          )}
        </div>
      </div> */}
      <div className="payment-details-section">
        <div className="row">
          <div className="col-12">
            <div className="total-payment-amount">
              <div>
                <h4>
                  {t("rental-to-pay-today")} : £{producttotalrate}
                </h4>
                <p>
                  <OverlayTrigger
                    key="right"
                    placement="right"
                    overlay={
                      <Tooltip
                        id={`tooltip-right`}
                        style={{ position: "fixed" }}
                      >
                        {t("refundable-deposit-tooltip")}
                      </Tooltip>
                    }
                  >
                    <Info className="info-icon me-1" size={18} />
                  </OverlayTrigger>
                  + {t("refundable-deposit-of")} £
                  {Number(orderdetails?.totalDepositAmount ?? 0).toFixed(2)}
                </p>
              </div>
            </div>
            <button
              onClick={handleSubmit}
              id="submit"
              className={`btn primary-btn payment-btn`}
            >
              {t("pay-now")}{" "}
              <span>£ {Number(totalPayablAmount ?? 0).toFixed(2)} </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentForm;
